import * as React from 'react';
import { IconRow, InfoColumn, StylelessButton, Title } from './_styles';
import { moveLayer } from '@src/actions';
const ZIndexMutator = () => (React.createElement(React.Fragment, null,
    React.createElement(InfoColumn, null,
        React.createElement(Title, null, "Z index"),
        React.createElement(IconRow, null,
            React.createElement(StylelessButton, { title: "Move to front", className: "material-icons", onClick: moveLayer(1) }, "flip_to_front"),
            React.createElement(StylelessButton, { title: "Move to back", className: "material-icons", onClick: moveLayer(-1) }, "flip_to_back")))));
export default ZIndexMutator;
